import React from 'react';
import PropTypes from 'prop-types';

import rotate from '../../assets/imgs/icon-refresh-team-code.svg';
import './RefreshTeamCode.scss';

const RefreshTeamCode = ({ onRefresh, teamCode }) => {
  return (
    <div className="refresh-team-code">
      <span className="refresh-team-code__text">Team code:</span>
      <span className="refresh-team-code__code">{teamCode}</span>
      <button className="refresh-team-code__button" onClick={onRefresh}>
        <img src={rotate} alt=""/>
      </button>
    </div>
  );
};

RefreshTeamCode.propTypes = {
  onRefresh: PropTypes.func, 
  teamCode: PropTypes.string
};

RefreshTeamCode.defaultProps = {
  onRefresh: ()=> {}, 
  teamCode: ""
};

export default RefreshTeamCode;